import Mutations from "./browser-preferences-mutations";
import Actions from "./browser-preferences-actions";
import Getters from "./browser-preferences-getters";
import DefaultState from "./browser-preferences-default-state";
const BrowserPreferencesStore = {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default BrowserPreferencesStore;